import { useState, useEffect, useCallback } from 'react';
import GeoPosition from '../../../../interfaces/geo-position';

export const FALLBACK_GEO_POSITION: GeoPosition = {
  lat: 56.9491,
  lon: 24.1106,
};

const useGeoPosition = () => {
  const [geoPosition, setGeoPosition] = useState(null);

  const round = useCallback((i) => Math.round(i * 10000) / 10000, []);

  useEffect(() => {
    if (!navigator?.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (coordinates) => {
        if (!coordinates?.coords) return console.log('Geolocation data error');

        const {
          coords: { latitude: lat, longitude: lon },
        } = coordinates;

        setGeoPosition({ lat: round(lat), lon: round(lon) });
      },
      (error) => {
        console.log('Geolocation request error', error);
        setGeoPosition(FALLBACK_GEO_POSITION);
      }
    );
  }, [round]);

  return geoPosition;
};

export default useGeoPosition;
